import './src/styles/global.css';

export const shouldUpdateScroll = ({ routerProps: { location }, prevRouterProps }) => {
  const samePage = prevRouterProps?.location?.pathname === location.pathname;

  // Ancora nella stessa pagina (es. /#features mentre sei già sulla home):
  // lascia che il browser scrolli alla sezione.
  if (location.hash && samePage) return true;

  // Hash cross-pagina (es. dal footer di /chi-siamo/ a /#features):
  // salta alla sezione una volta montata, altrimenti in cima.
  // Scroll istantaneo per non innescare l'animazione di html{scroll-behavior:smooth}.
  if (location.hash) {
    const target = document.querySelector(location.hash);
    if (target) {
      target.scrollIntoView({ behavior: 'instant' });
      return false;
    }
  }

  // Navigazione normale: salto in cima ISTANTANEO.
  // Non usiamo `return [0, 0]` perché lo scroll di Gatsby rispetta
  // scroll-behavior:smooth e l'animazione si interrompe a metà transizione.
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  return false;
};
